export const SITE = {
  TYPES: {
    MAIN: 'main',
    MULTIEVENT: 'multievent'
  }
};
